import { UIEvent } from 'react';

function targetIsDocument(target: EventTarget | null | undefined): target is Document {
    return target !== null && target !== undefined && (target as Document).documentElement !== undefined;
}

function useOnScroll(callback: (event: Event | UIEvent<HTMLDivElement>) => void, options?: { threshold: number }) {
    return (event: Event | UIEvent<HTMLDivElement>) => {
        const target = targetIsDocument(event.currentTarget)
            ? event.currentTarget.documentElement
            : event.currentTarget;
        const threshold = options?.threshold
            ? (target as HTMLElement).offsetHeight + options.threshold
            : (target as HTMLElement).offsetHeight;

        if ((target as Element).scrollHeight - Math.ceil((target as Element).scrollTop) <= threshold) {
            callback(event);
        }
    };
}

export default useOnScroll;
